import { SHIPPING_COLUMNS } from './shippingConfig';
import moment from 'moment';

const hiddenColumns = new Set(['CurrentPlanShipDate', 'ExpectedArrivalTime', 'CheckedIn', 'Packed', 'Audit', 'Shipped', 'DeliveryDate', 'QuoteLookup', 'FinalQuote']);
export const SHIPPING_VIEW_CATEGORY = 'ShippingDataEntryViews';
export const defaultShippingView = () => ({
  visibleColumns: SHIPPING_COLUMNS['data-entry'].filter(({ key }) => !hiddenColumns.has(key)).map(({ key }) => key),
  search: '', status: 'all', startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'), endDate: moment().add(3, 'days').format('YYYY-MM-DD'), pageSize: 100,
});
export const normalizeShippingView = (config) => {
  if (!config || typeof config !== 'object' || Array.isArray(config)) throw new Error('Invalid saved view.');
  const defaults = defaultShippingView();
  const allowed = new Set(SHIPPING_COLUMNS['data-entry'].map(({ key }) => key));
  const visibleColumns = Array.isArray(config.visibleColumns) ? [...new Set(config.visibleColumns.filter((key) => allowed.has(key)))] : defaults.visibleColumns;
  return {
    ...defaults,
    visibleColumns: visibleColumns.length ? visibleColumns : defaults.visibleColumns,
    ...Object.fromEntries(['search', 'startDate', 'endDate'].map((key) => [key, typeof config[key] === 'string' ? config[key] : defaults[key]])),
    status: ['open', 'shipped', 'all'].includes(config.status) ? config.status : 'all',
    pageSize: [25, 50, 100].includes(Number(config.pageSize)) ? Number(config.pageSize) : defaults.pageSize,
  };
};
